import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const OutboundGenentechChargebackPage = () => {
    const fileName = 'Chargeback Source Data';
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const history = useHistory();
    const [chargeback, setChargeback] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [showToaster, setShowToaster] = useState(false);
    // let Message;
    const [hasError, setHasError] = useState(false);
    const columns = [
        {
            Header: "Distributor HIN #",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
        },
        {
            Header: "Debit Memo/Document #",
            accessor: "DebitMemoNum",
            filter: "DebitMemoNum",
            sortType: "basic",
        },
        {
            Header: "Total line count",
            accessor: "TotalLineCount",
            filter: "TotalLineCount",
            sortType: "basic",
        },
        {
            Header: "Total Amount Requested",
            accessor: "TotalAmountRequested",
            filter: "TotalAmountRequested",
            sortType: "basic",
        },
        {
            Header: "340B ID/ HIN",
            accessor: "MemberIDHIN",
            filter: "MemberIDHIN",
            sortType: "basic",
        }, {
            Header: "Invoice Date",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            width:110,
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        }, {
            Header: "Invoice #",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
            width:90,
        },
        {
            Header: "Product NDC-11",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
            width:130,
        },
        // {
        //     Header: "Product Description",
        //     accessor: "ProductDescription",
        //     filter: "ProductDescription",
        //     sortType: "basic",
        // },
        {
            Header: "Contract ID #",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
            width:120,
        },
        {
            Header: "Qty",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
            width:80,
        },
        {
            Header: "Orig WAC Price Per Pkg",
            accessor: "DACperIUOREUORGram",
            filter: "DACperIUOREUORGram",
            sortType: "basic",
        },
        {
            Header: "Contract Price Per Pkg",
            accessor: "ContractpriceperIUOREUORGram",
            filter: "ContractpriceperIUOREUORGram",
            sortType: "basic",
        },
        {
            Header: "Chargeback Amount (Ext Total)",
            accessor: "ChargebackAmount",
            filter: "ChargebackAmount",
            sortType: "basic",
        },
        // {
        //     Header: "Distributor HIN",
        //     accessor: "DistributorHIN",
        //     filter: "DistributorHIN",
        //     sortType: "basic",
        // },
        // {
        //     Header: "Debit Memo",
        //     accessor: "DebitMemo",
        //     filter: "DebitMemo",
        //     sortType: "basic",
        // },
    
    ];
    async function headerData(chargeback) {
        var data_to_download = []
        if(chargeback.length != 0){
        chargeback.map((data, pidex) => {
            let record_to_download = {}
            columns.map((col, cindex) => {
                record_to_download[columns[cindex].Header] = chargeback[pidex][columns[cindex].accessor]
            })
            data_to_download.push(record_to_download)
        })}
        else {
            let record_to_download = {}
            columns.map((col, cindex) => {
                record_to_download[columns[cindex].Header] = ""
            })
            data_to_download.push(record_to_download)
        }
        exportToCSV(data_to_download)
    }
    const exportToCSV = (data_to_download) => {
        var wscols = [{ wch: 20, color: 'aabbcc' }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const ws = XLSX.utils.json_to_sheet(data_to_download);
        ws["!cols"] = wscols;
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "Chargeback Source Data");
    }
    useEffect(() => {
        getChargeback();
    }, [])
    async function getChargeback() {
        setLoading(true);
        let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=ChargebacksWeekly&TaskTypeCode=GenentechChargebacks`;
        await _HttpServices
            .getData(url)
            .then((data) => {
                const chargebackResult = data.data;
                if(chargebackResult.length > 0){
                    chargebackResult.map((res) => {
                         res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY');
                         res.TotalAmountRequested = "$"+(res.TotalAmountRequested*1).toFixed(2)
                         res.ContractpriceperIUOREUORGram = (res.ContractpriceperIUOREUORGram*1).toFixed(2)
                         res.ChargebackAmount = (res.ChargebackAmount*1).toFixed(2)
                         res.DACperIUOREUORGram =(res.DACperIUOREUORGram*1).toFixed(2)
                         })
                  }
                setChargeback(chargebackResult);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                // Message = e.response.data.Message;
                // setShowToaster(true);
                setHasError(true);
            });
    }
    const EditRecords = () =>{
        localStorage.setItem("chargeback",JSON.stringify(chargeback));
        history.push("/GenentechChargebacksEdit")
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Genentech Chargeback Source Data</h2>
                {loading ? <Loader /> : null}
                <div>
                {chargeback.length > 0 && (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                <Button type="submit" className="ml-2" onClick={() =>getExcel(columns,chargeback,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
            {/* Toaster */}
            {/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
            <Row>
                <Col md={12}>
                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Chargeback Source Data.</p> :
                                <Fragment>
                                    {chargeback.length > 0 ? (
                                        <ReactTable columns={columns} data={chargeback} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );

}

export default OutboundGenentechChargebackPage;